import { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { setSearchQuery } from "../../redux/actions";
import { useLocation } from 'react-router-dom';

function Search({ query, setSearchQuery }) {
  const [isActive, setIsActive] = useState(false);
  const inputRef = useRef(null); // Ref for input field

  useEffect(() => {
    if (!query) setIsActive(false);
  }, [query]);

  // Handle icon click to focus input
  const handleIconClick = () => {
    setIsActive(true);
    setTimeout(() => inputRef.current?.focus(), 100); // Ensuring focus after animation
  };

  const location = useLocation();

  // Only render the Navbar on the home route ("/")
  if (location.pathname !== '/') {
    return null;  // Don't render anything for other routes
  }

  return (
    <div className="relative w-full flex justify-end px-4 mt-4 sm:mt-0">
      {/* Pushes search bar below the title on mobile */}
      <motion.div
        className="relative flex items-center bg-white border border-gray-300 rounded-full shadow-sm overflow-hidden"
        initial={{ width: 40 }}
        animate={{ width: isActive || query ? 220 : 40 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{ maxWidth: "220px", position: "relative", top: 0 }}
      >
        <SearchOutlined
          className="w-5 h-5 mx-3 text-gray-600 cursor-pointer"
          onClick={handleIconClick}
        />
        <Input
          ref={inputRef}
          placeholder="Search..."
          className={`font-sofia bg-transparent border-none focus:ring-0 px-2 transition-all duration-300
            ${isActive || query ? "w-full opacity-100" : "w-0 opacity-0"}
          `}
          value={query}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setIsActive(true)}
          onBlur={() => !query && setIsActive(false)}
        />
      </motion.div>
    </div>
  );
}

// Map state and actions to props
const mapStateToProps = (state) => ({
  query: state.search.query,
});

const mapDispatchToProps = {
  setSearchQuery,
};

// Connect component to Redux
export default connect(mapStateToProps, mapDispatchToProps)(Search);
